import React from "react";
import PropTypes from "prop-types";

import { Card, Icon, Loader } from "semantic-ui-react";

import Tooltip from "components/Tooltip";

function OnboardingWidget({
  welcomeMessage,
  title,
  children,
  videoSection,
  videoPosition,
  items,
  ...props
}) {
  const videoPositionsMap = {
    top: "column",
    left: "row",
    bottom: "column-reverse",
    right: "row-reverse",
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        textAlign: "center",
        justifyContent: "center",
        height: "100%",
        gap: "1em",
      }}
      {...props}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "1em",
        }}
      >
        <h2 style={{ margin: 0 }}>{title}</h2>
        <h4 style={{ color: "#536DFE", margin: 0 }}>{welcomeMessage}</h4>
      </div>
      <div
        data-test="use-cases-container"
        style={{
          display: "flex",
          gap: "1em",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: videoPositionsMap[videoPosition || "top"],
        }}
      >
        {videoSection}
        <div style={{ display: "flex", flexDirection: "column", gap: "1em" }}>
          <div
            style={{
              display: "flex",
              gap: "1em",
              flexWrap: "wrap",
              justifyContent: "center",
            }}
          >
            {items.map((item) => {
              return (
                <Tooltip
                  key={item.title}
                  title={item.tooltip || ""}
                  position="top center"
                >
                  <div data-test="use-case-card-wrapper">
                    <Card
                      raised
                      data-test="use-case-card"
                      data-dd-action-name={item.action}
                      onClick={item.onClick}
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        border: "1px solid",
                        boxShadow: "none",
                        borderColor: "#2D9CDB",
                        width: "250px",
                        height: "230px",
                        margin: 0,
                        cursor: "pointer",
                        opacity: item.disabled ? 0.5 : 1,
                        pointerEvents: item.disabled ? "none" : "auto",
                      }}
                    >
                      <Card.Content
                        style={{ display: "flex", flexDirection: "column" }}
                      >
                        <Card.Header>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              flexDirection: "column",
                              gap: "0.5em",
                            }}
                          >
                            {item.installed && (
                              <Icon
                                name="check circle outline"
                                data-test="use-case-installed-icon"
                                color="green"
                                style={{
                                  position: "absolute",
                                  top: "10px",
                                  right: "2px",
                                }}
                              />
                            )}

                            <Icon name={item.icon} />

                            <span style={{ fontSize: "21px" }}>
                              {item.title}
                            </span>
                          </div>

                          {item.loading && (
                            <Loader
                              data-test="use-case-loader"
                              active
                              size="mini"
                              style={{ top: "8%", left: "93%" }}
                            />
                          )}
                        </Card.Header>

                        <Card.Description
                          style={{
                            margin: 0,
                            alignContent: "center",
                            flexGrow: 2,
                          }}
                        >
                          {item.description}
                        </Card.Description>

                        <div
                          style={{
                            alignSelf: "self-start",
                            display: "flex",
                            alignItems: "center",
                            width: "80%",
                            height: "20px",
                          }}
                        >
                          {item.footer}
                        </div>
                      </Card.Content>
                    </Card>
                  </div>
                </Tooltip>
              );
            })}
          </div>

          {children}
        </div>
      </div>
    </div>
  );
}

OnboardingWidget.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      onClick: PropTypes.func.isRequired,
      icon: PropTypes.string,
      tooltip: PropTypes.string,
      installed: PropTypes.bool,
      disabled: PropTypes.bool,
      loading: PropTypes.bool,
      action: PropTypes.string,
      footer: PropTypes.node,
    })
  ),

  welcomeMessage: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  videoSection: PropTypes.node,
  videoPosition: PropTypes.oneOf(["top", "left", "bottom", "right"]),
  children: PropTypes.node,
};

OnboardingWidget.defaultProps = {
  videoSection: undefined,
  children: undefined,
  videoPosition: "top",
  items: [],
};

export default OnboardingWidget;
